<template>
  <div class="jsfc">
    <div class="pageBanner" :style="pageBanner"></div>
    <div class="page_box">
      <div class="page_nav"><span>{{ pageHeader.Name }}</span></div>
      <div class="page_main">
        <div class="page_head">
          <p><span>当前位置：</span><router-link to="/">首页</router-link><router-link :to="pageHeader.Router">{{pageHeader.Name}}</router-link></p>
        </div>
        <div class="page_content ThisDown">
          <ul class="jsfcType">
            <li v-for="(i,index) in jsfcList" :key="index" ><router-link :to="{path:'/Detail',query:{ID:i.ID}}">
              <div class="imgBox"><img :src="i.Cover" alt=""></div>
              <div class="font">
                <h3>{{i.Title}}</h3>
                <p>{{i.Describe}}</p>
              </div>
            </router-link>
            <!-- {{i}} -->
            </li>
          </ul>
          <div class="page_move" v-show="pageCount>1">
            <span @click="pageMove(1)">首页</span>
            <span @click="pageMove(curPage-1)">上一页</span>
            <span class="pager firsts" @click="pageMove(curPage-2)" v-show="curPage-2>0">{{ curPage-2 }}</span>
            <span class="pager first" @click="pageMove(curPage-1)" v-show="curPage-1>0">{{ curPage-1 }}</span>
            <span class="pager second on" @click="pageMove(curPage)">{{ curPage }}</span>
            <span class="pager third" @click="pageMove(curPage+1)" v-show="curPage+1<pageCount+1">{{ curPage+1 }}</span>
            <span class="pager thirds" @click="pageMove(curPage+2)" v-show="curPage+2<pageCount+1">{{ curPage+2 }}</span>
            <span @click="pageMove(curPage+1)">下一页</span>
            <span @click="pageMove(pageCount)">尾页</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Base } from "../assets/js/Base"

export default {
  name: 'jsfc',
  data () {
    return {
      pageBanner: '',
      jsfcList: '',
      pageHeader: '',
      pageSize: 6,//翻页每页显示数据
      curPage: 1,//当前页面
      pageCount: '',//总共页面数
    }
  },
  methods:{
    dateFormat: function(date,format){
      var data = String(date);
      var str = '';
      if (format == "xx-xx") {
        for (let i = 1; i < data.length; i++) {
          if (i>4) {
            str += data[i];
          }
        }
      }else if(format == "xx"){
        for (let i = 1; i < data.length; i++) {
          if (i>7) {
            str += data[i];
          }
        }
      }else if(format == "xxxx-xx"){
        for (let i = 0; i < data.length; i++) {
          str += data[i];
          if (i>5) {
            break;
          }
        }
      }
      return str;
    },
    pageMove: function(p){
      if (p>this.pageCount) {
        return false;
      }else if(1>p){
        return false;
      }
      this.curPage = p;
      this.jsfcList = Base.GetNewsInfoByCid(3567,this.curPage,this.pageSize);
    }
  },
  created() {
    // 子页面banner图
    this.pageBanner = "background:url(" + Base.GetFilesInfoByCid(49)[0].FileUrl+") center no-repeat;";
    this.pageHeader = Base.GetColumnByid(3567);
    this.jsfcList = Base.GetNewsInfoByCid(3567,this.curPage,this.pageSize);
    console.log(this.pageHeader);
    this.pageCount = Math.ceil(this.jsfcList[0].Total/this.pageSize);
  }
}
</script>


<style>
.jsfcType{width: 100%;overflow: hidden;}
.jsfcType li{width: 420px;height: 237px;background-color: #eeeeee;float: left;margin-bottom: 24px;}
.jsfcType li:nth-child(even){float: right;}
.jsfcType li .imgBox{width: 150px;height: 191px;float: left;margin-left: 20px;margin-top: 23px;}
.jsfcType li .imgBox img{display: block;object-fit: cover;width: 100%;height: 100%;}
.jsfcType li .font{width: 211px;margin-right: 20px;float: right;}
.jsfcType li .font h3{font-size: 16px;font-weight: normal;font-stretch: normal;letter-spacing: 2px;color: #333333;line-height: 1.25;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;padding-top: 35px;}
.jsfcType li .font p{font-size: 14px;font-weight: normal;font-stretch: normal;line-height: 24px;letter-spacing: 0px;color: #333333;margin-top: 10px;    overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 6;-webkit-box-orient: vertical;}
.jsfcType li:hover .font h3{color: #37acd4;}
.page_move{margin-top: 30px;}
</style>



// WEBPACK FOOTER //
// src/components/jsfc.vue